
// Add components here as needed,
// and then add an entry for it in COMPONENT_COLOURS
export enum LoggerComponent {
  Service = 'Service',
}

const COMPONENT_COLOURS = {
  // https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#color_keywords
  // [LoggerComponent.CodebookTree]: 'lightseagreen',
  // [LoggerComponent.DocumentList]: 'darkseagreen',
  // [LoggerComponent.FileUpload]: 'greenyellow',
  [LoggerComponent.Service]: 'peachpuff',
}




export enum LogLevel {
  ALL = 0,
  INFO = 1,
  WARN = 2,
  DEBUG = 3,
  ERROR = 4,
}

export class Logger {
  private constructor() {}

  private static appLevel : LogLevel = LogLevel.ALL;

  static setLevel( newLogLevel : LogLevel ) { Logger.appLevel = newLogLevel; }

  private static shouldLog( logLevel : LogLevel ) { return logLevel >= Logger.appLevel; }

  private static doPrefix(component?: LoggerComponent, ...data: any[]) {
    if( component && COMPONENT_COLOURS[component] ) {
      // https://developer.mozilla.org/en-US/docs/Web/API/console#outputting_text_to_the_console
      const pre = [
        '%c%s',
        `background: ${COMPONENT_COLOURS[component]}; padding: 4px; border-radius: 4px; line-height: 20px;`,
        component,
      ]
      data.unshift(...pre);
    } else {
      data.unshift(component);
    }
    return data;
  }

  public static info(...data: any[]):void;
  public static info(component?: LoggerComponent, ...data: any[]):void {
    Logger.shouldLog(LogLevel.INFO) && console.info(...Logger.doPrefix(component, '[INFO] > ', ...data));
  }

  public static log(...data: any[]):void;
  public static log(component?: LoggerComponent, ...data: any[]):void {
    Logger.shouldLog(LogLevel.INFO) && console.log(...Logger.doPrefix(component, ...data));
  }

  public static debug(...data: any[]):void;
  public static debug(component?: LoggerComponent, ...data: any[]):void {
    Logger.shouldLog(LogLevel.DEBUG) && console.debug(...Logger.doPrefix(component, '[DEBUG] > ', ...data));
  }

  public static error(...data: any[]):void;
  public static error(component?: LoggerComponent, ...data: any[]):void {
    Logger.shouldLog(LogLevel.ERROR) && console.error( ...Logger.doPrefix(component, ...data));
  }
}
